import _ from "lodash";
import React from "react";

import { Input } from "./Input";

export const ReadOnlyInput = props => (
  <Input {...props} onChange={_.noop} disabled={true} />
);
